import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IDeleteAdminProfilesParams {
  profileLuids: string[];
}

export interface IDeleteAdminProfilesResult extends IResult {
}

export class DeleteAdminProfilesRequest extends Request<IDeleteAdminProfilesParams, IDeleteAdminProfilesResult> {
  constructor(params: IDeleteAdminProfilesParams) {
    super('deleteAdminProfiles', params);
  }
}
